import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import {
  fetchApprovalManagerData,
  fetchStaffLeavesData,
  fetchStaffLeaveStatsData,
} from "../../../redux/reducers/apiSlice";
import BackAddBtns from "../../Open-pages/target-matrics/common/BackAddBtns";
import StaffLeaveDetTbFilters from "../admin/StaffLeaveDetTbFilters";
import CommonMobTb from "../mobile-version/CommonMobTb";
import LeaveDates from "../admin/LeaveDates";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { convertStraight, convertThenFormat } from "../../common-data/Converts";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const StaffListingsAdmin = ({ userInfoData, isOpenPage }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { staffLeaves, staffLeaveStats, approvalManager } = useSelector(
    (state) => state.api
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const iniAM = {
    isApprovalManager: false,
    approvalManagerFor: "",
  };
  const [approvalManagerInfo, setApprovalManagerInfo] = useState(iniAM);
  const [isPage, setIsPage] = useState(0);
  const initialFilters = {
    selectedGym:
      !isAdmin && !isClusterManager
        ? {
            label: userInfoData?.gym_name || "",
            value: userInfoData?.gym_id || "",
          }
        : "",
    selectedOtherUsers:
      !isAdmin && !isClusterManager
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.user_id || userInfoData?.uid || "",
          }
        : "",
    selectedLeaveStatus: "",
    selectedStartDate: "",
    selectedEndDate: "",
  };
  const [allFilters, setAllFilters] = useState(initialFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    gym_id: allFilters.selectedGym?.value || "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    user_id: allFilters.selectedOtherUsers?.value || "",
    approval_status: allFilters.selectedLeaveStatus?.value || "",
    reporting_manager:
      isOpenPage || approvalManagerInfo.isApprovalManager
        ? userInfoData?.user_id || userInfoData?.uid
        : "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    staffLeavesStats: {},
    staffLeavesData: [],
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: "",
    leaveDetails: [],
  };
  const [modValues, setModValues] = useState(iniModValues);

  const sortedStaffLeaveDetails =
    tbDatas.staffLeavesData?.length > 0
      ? [...tbDatas.staffLeavesData].sort((a, b) => {
          const dateA = new Date(a.leave_date);
          const dateB = new Date(b.leave_date);
          return dateB - dateA;
        })
      : [];

  const approvalManagerFor =
    (isOpenPage || approvalManagerInfo.isApprovalManager) &&
    sortedStaffLeaveDetails?.length > 0
      ? sortedStaffLeaveDetails[0]?.account_type === "receptionist"
        ? "Sales Executive"
        : sortedStaffLeaveDetails[0]?.account_type
      : "";

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickReset = () => {
    setAllFilters(initialFilters);
    setFilters(iniFilters);
  };

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  function getStaffLeaves(filters) {
    dispatch(
      fetchStaffLeavesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getStaffLeavesStats(filters) {
    const updatedFilters = {
      ...filters,
      filter_type: "staff_leave_stats",
    };

    dispatch(
      fetchStaffLeaveStatsData({
        filters: updatedFilters,
        token: userInfoData?.token,
      })
    );
  }

  function callCombinedFunctions() {
    getStaffLeaves(filters);
    getStaffLeavesStats(filters);
  }

  function getApprovalManagerList(filter) {
    dispatch(
      fetchApprovalManagerData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin && !isClusterManager
  //       ? {
  //           label: userInfoData?.gym_name || "",
  //           value: userInfoData?.gym_id || "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    const filter = {
      user_id: userInfoData?.uid || userInfoData?.user_id,
    };

    if (filter) {
      getApprovalManagerList(filter);
    }
  }, []);

  useEffect(() => {
    if (approvalManager?.status && approvalManager?.data?.length > 0) {
      setApprovalManagerInfo((prevs) => ({
        ...prevs,
        isApprovalManager: true,
        approvalManagerFor: approvalManager.data?.[0]?.for_ac_type,
      }));
    } else {
      setApprovalManagerInfo(iniAM);
    }
  }, [approvalManager]);

  useEffect(() => {
    if (approvalManagerInfo.isApprovalManager) {
      setFilters((prevs) => ({
        ...prevs,
        reporting_manager: userInfoData?.user_id || userInfoData?.uid || "",
      }));
    }
  }, [approvalManagerInfo.isApprovalManager]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      gym_id: allFilters.selectedGym?.value || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      user_id: allFilters.selectedOtherUsers?.value || "",
      approval_status: allFilters.selectedLeaveStatus?.value || "",
      reporting_manager:
        isOpenPage || approvalManagerInfo.isApprovalManager
          ? userInfoData?.user_id || userInfoData?.uid
          : "",
    }));
  }, [allFilters, isPage, approvalManagerInfo.isApprovalManager]);

  useEffect(() => {
    if (approvalManager) {
      getStaffLeaves(filters);
      getStaffLeavesStats(filters);
    }
  }, [filters, approvalManager]);

  useEffect(() => {
    if (staffLeaveStats?.status && staffLeaveStats?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesStats: staffLeaveStats.data?.[0],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesStats: {},
      }));
    }
  }, [staffLeaveStats]);

  useEffect(() => {
    if (staffLeaves?.status && staffLeaves?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesData: staffLeaves.data || [],
        pagination: staffLeaves?.pagination || [],
        staffLeaveStats: {},
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesData: [],
        pagination: [],
        staffLeaveStats: {},
      }));
    }
  }, [staffLeaves]);

  const staffTbColumns = [
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className="actionBtn icon download"
            disabled={!row?.required_doc}
            style={{
              cursor: row?.required_doc ? "pointer" : "not-allowed",
            }}
          >
            <a href={row?.required_doc}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-cloud-arrow-down"
                viewBox="0 0 16 16"
                style={{
                  color: row?.required_doc ? "#CD0909" : "gray",
                  width: "35px",
                  height: "35px",
                }}
              >
                <path
                  fillRule="evenodd"
                  d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                />
                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
              </svg>
            </a>
          </button>

          <button
            className="actionBtn icon view"
            onClick={(e) =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                leaveDetails:
                  row?.leave_dates_with_status?.length > 0
                    ? row.leave_dates_with_status
                    : [],
                cardType: "view",
                rowData: row,
              }))
            }
            style={{
              border:
                row?.leave_dates_with_status?.length > 0
                  ? "1px solid #bc0909"
                  : "1px solid #9C9C9C",
              color:
                row?.leave_dates_with_status?.length > 0
                  ? "#bc0909"
                  : "#9C9C9C",
              borderRadius: "12px",
              cursor:
                row?.leave_dates_with_status?.length > 0
                  ? "pointer"
                  : "not-allowed",
            }}
            disabled={row?.leave_dates_with_status?.length === 0}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrows-angle-expand"
              viewBox="0 0 16 16"
              style={{
                color:
                  row?.leave_dates_with_status?.length > 0
                    ? "#bc0909"
                    : "#9C9C9C",
                width: "20px",
                height: "20px",
              }}
            >
              <path
                fillRule="evenodd"
                d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
              />
            </svg>
          </button>
        </div>
      ),
    },
    {
      dataField: "user_name",
      text: "Staff Info",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.user_name || "NA"} <small>({row?.account_type || ""})</small>
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "matrix_status",
      text: "Leave Terms fulfilled",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.matrix_status === "matched" ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_action_pending",
      text: "Approval Action",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_action_pending === "true" ? (
              <CrossCircleIcon />
            ) : (
              <CheckCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "reporting_manager_name",
      text: "Approval Manager",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.reporting_manager_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.reporting_manager_mobile || ""}
              <br />
              {row?.reporting_manager_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "aprv_rej_by_name",
      text: "Approved/Rejected By",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.aprv_rej_by_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.aprv_rej_by_mobile || ""}
              <br />
              {row?.aprv_rej_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "apply_date",
      text: "Apply Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.apply_date ? convertStraight(row.apply_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "leave_category_name",
      text: "leave category name",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth150 withPadding borderRdius8"
            style={{
              background: "#157EF9",
              color: "#FFF",
            }}
          >
            {row?.leave_category_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "total_leave_days_approved",
      text: "Approved/Rejected Leaves",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            <small
              style={{
                background: "#379C00",
                color: "#FFF",
                padding: "2px 10px",
                borderRadius: "4px",
              }}
            >
              {row?.total_leave_days_approved || 0}
            </small>{" "}
            /{" "}
            <small
              style={{
                background: "#F13434",
                color: "#FFF",
                padding: "2px 10px",
                borderRadius: "4px",
              }}
            >
              {row?.total_leave_days_rejected || 0}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "days_before",
      text: "Max Leave(Monthly)",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.no_ofdays || 0} Day(S)</span>;
      },
    },
    {
      dataField: "days_before",
      text: "Apply Before",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.days_before || 0} Day(S)</span>;
      },
    },
    {
      dataField: "is_paid",
      text: "Paid Leave",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_paid ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "doc_required",
      text: "doc required",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.doc_required ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "approval_required",
      text: "approval required",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.approval_required ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "description",
      text: "Remarks",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row.description?.length <= 15 ? (
              row.description
            ) : row.description?.length >= 15 ? (
              <>
                {row.description?.substring(0, 15)}
                <b
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardType: "description",
                      description: row.description,
                    }))
                  }
                >
                  ...Read More
                </b>
              </>
            ) : (
              "NA"
            )}
            {/* {row?.description || "NA"} */}
          </span>
        );
      },
    },
    {
      dataField: "salary",
      text: "Staff Salary(Monthly)",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.salary || 0)}
          </span>
        );
      },
    },
    {
      dataField: "deducted_salary",
      text: "Deducted Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.deducted_salary || 0)}
          </span>
        );
      },
    },
    {
      dataField: "total_leave_days_used",
      text: "Taken/Total Leaves(Year)",
      formatter: (_, row) => {
        return (
          <span className="tb-data bold">
            {row?.total_leave_days_used || 0}/{row?.yearly_leave || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_leave_days_remaining",
      text: "Remaining Leaves(Year)",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.total_leave_days_remaining || 0}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Add Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardType === "description" ? "mod-width-50p" : ""
          }`}
        >
          <ModalHeadAndClose
            title={`${
              modValues.cardType === "view"
                ? "Leave Details"
                : modValues.cardType === "description"
                ? "Remarks"
                : ""
            } `}
            onClose={closeModal}
          />
          {modValues.cardType === "view" ? (
            <LeaveDates
              userInfoData={userInfoData}
              leaveDetails={modValues.leaveDetails}
              rowData={modValues.rowData}
              callFunction={() => callCombinedFunctions()}
              closeModal={closeModal}
              approvalManagerInfo={approvalManagerInfo}
            />
          ) : modValues.cardType === "description" ? (
            <div className="discussionModalMessage mt30">
              <p className="message">
                {modValues.description || "No Content Available"}
              </p>
            </div>
          ) : null}
        </div>
      </Modal>

      {isOpenPage ? (
        <BackAddBtns
          onClickBack={isOpenPage ? handleBack : null}
          isCustom={isOpenPage}
          onClickReload={() => callCombinedFunctions()}
        />
      ) : null}

      <StaffLeaveDetTbFilters
        userInfoData={userInfoData}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        prevGymId={filters.gym_id}
        staffLeaveStats={tbDatas.staffLeavesStats}
        isLMAdminDate={true}
        approvalManagerFor={
          (approvalManagerInfo.isApprovalManager || isOpenPage) &&
          (approvalManagerInfo.approvalManagerFor || approvalManagerFor)
            ? approvalManagerInfo.approvalManagerFor || approvalManagerFor
            : null
        }
      />

      <CommonMobTb
        tbData={sortedStaffLeaveDetails}
        tbColumns={staffTbColumns}
        tbPaignation={tbDatas.pagination}
        isPage={isPage}
        setIsPage={setIsPage}
        setModValues={setModValues}
        userInfoData={userInfoData}
      />
    </>
  );
};

export default StaffListingsAdmin;
